import React from 'react';

import { BaseInputField, BaseInputFieldProps } from './BaseInputField';

export const EmailField = (props: BaseInputFieldProps) => {
  return <BaseInputField type="email" {...props} />;
};
